module.exports = __webpack_public_path__ + "static/media/about1.b094a97a.jpg";